<div style="margin: 10px 10px 10px 10px;">

	<port-access-vlan-editor [portTableHeightVh]="100" [portTableHeightPx]="-510" [portTableMinHeight]="150">
	</port-access-vlan-editor>

</div>
